export function normalizeIsbn(value) {
    return String(value || "").replace(/\D/g, "");
}

export function isbnDigits(value) {
    const digits = normalizeIsbn(value);
    return digits.length === 13 || digits.length === 10 ? digits : null;
}

/**
 * Display ISBN without hyphens. Publisher group length varies (2–6 digits),
 * so a fixed hyphen pattern (e.g. 978-3-1501-5461-8) is often wrong.
 */
export function formatISBN(value) {
    const digits = normalizeIsbn(value);
    if (digits.length === 13 || digits.length === 10) return digits;
    return value || "";
}
